/* eslint-disable */
<template>
<div>
    <div class="page_margins">
        <!-- begin: page_margins -->
        <div id="seite" class="page">
            <!-- begin: seite -->
            <a name="seitenmarke" id="seitenmarke"></a>

            <div id="kopf">
                <!-- begin: kopf -->
                <div id="logo">
                    <a href="/"><img src="https://www.ikgf.uni-erlangen.de/grafiken/ikgf/IKGF-logo.png" alt="International Consortium for Research in the Humanities. Fate, Freedom an Prognostication – Strategies for Coping with the Future in East Asia and Europe" width="560" height="126"></a>
                </div>
                <div id="titel">
                    <h1>IKGF – Bibliography</h1>
                </div>

                <div id="suche">
                    <h2><a name="suche">Suche</a></h2>
                    <form method="get" action="/suche.shtml">
                        <p>
                            <label for="suchbegriff">Search:</label>
                            <input id="suchbegriff" name="Suchbegriff" type="text" value="Enter search term" onfocus="if(this.value=='Enter search term')this.value='';" onblur="if(this.value=='')this.value='Enter search term';" maxlength="100">
                            <input type="hidden" name="suchraum" value="homepage">
                            <input type="submit" value="Search">
                        </p>
                    </form>
                </div>

                <div id="breadcrumb">
                    <h2>You are here: </h2>
                    <p> <img src="https://www.ikgf.uni-erlangen.de/img/breadcrumbarrow.gif" height="9" width="20" alt=" "><strong>Bibliography</strong></p>
                </div>
                <div id="sprungmarken">
                    <h2>Sprungmarken</h2>
                    <ul>
                        <li class="first"><a href="#contentmarke">Zum Inhalt springen</a><span class="skip">. </span></li>
                        <li><a href="#bereichsmenumarke">Zur Navigation springen</a><span class="skip">. </span></li>
                        <li class="last"><a href="#hilfemarke">Zu den allgemeinen Informationen springen</a><span class="skip">. </span></li>
                    </ul>
                </div>

                <div id="hauptmenu">
                    <h2 class="skip"><a name="hauptmenumarke" id="hauptmenumarke">Zielgruppennavigation</a></h2>

                </div>

            </div> <!-- end: kopf -->
            <hr id="nachkopf">
            <div id="main">
                <!-- begin: main -->
                <div id="menu">
                    <!-- begin: menu -->
                    <div id="bereichsmenu">
                        <h2><a name="bereichsmenumarke" id="bereichsmenumarke">Navigation</a></h2>
                        <ul id="navigation">
                            <li class="first"><a class="aktiv" href="http://www.ikgf.uni-erlangen.de/index.shtml">Home</a><span class="skip">. </span>
                                <ul id="hauptnavigation">

                                    <li class="first "><a href="http://www.ikgf.uni-erlangen.de/events/">Events</a></li>
                                    <li><a href="//www.ikgf.uni-erlangen.de/news/">News</a></li>
                                    <li><a href="//www.ikgf.uni-erlangen.de/people.shtml">People</a></li>
                                    <li><a href="//www.ikgf.uni-erlangen.de/research/">Research</a></li>
                                    <li><a href="//www.ikgf.uni-erlangen.de/publications/">Publications</a></li>
                                    <li><a href="//www.ikgf.uni-erlangen.de/videos/">Videos</a></li>
                                    <li class="on"><span class="aktiv">Bibliography</span><span class="skip">. </span>
                                        <ul class="submenu">
                                            <li>
                                                <router-link to="/topics">Topics <template v-if="noOfPublications > 0">({{selectedTopics.length}}/{{topics.length}})</template></router-link>
                                            </li>
                                            <li>
                                                <router-link to="/publications">Publications<template v-if="noOfPublications > 0"> ({{noOfPublications}})</template></router-link>
                                            </li>
                                            <li class="lastCHILD">
                                                <router-link to="/authors">Authors <template v-if="selectedAuthors.length > 0">({{selectedAuthors.length}}/{{authors.length}})</template></router-link>
                                            </li>
                                            <!-- <li class="lastCHILD" ><router-link to="/keywords">Keywords</router-link></li> -->
                                            <!-- <li class="lastCHILD "><router-link to="/about">About</router-link></li> -->
                                        </ul>
                                    </li>
                                    <li class="last "><a href="//www.ikgf.uni-erlangen.de/contact.shtml">Contact</a></li>
                                </ul>
                            </li>
                        </ul>

                    </div>
                    <div id="kurzinfo">

                        <h2 class="skip">Kurzinfo</h2>

                        <div class="infologo">
                            <p>
                                <a title="Link to &quot;Bundesministerium für Bildung und Forschung&quot; website" href="https://www.bmbf.de/"><img src="https://www.ikgf.uni-erlangen.de/grafiken/ikgf/BMBF_Logo_EN200x96.png" width="200" height="121" alt="Bundesministerium für Bildung und Forschung"></a>
                            </p>
                            <p>
                                <a title="Zum Portal der Friedrich-Alexander-Universität" href="https://www.fau.de"><img src="https://www.ikgf.uni-erlangen.de/img/logos/fau/fau-logo-weissbg-180px.gif" width="180" height="50" alt="Friedrich-Alexander - Universität Erlangen-Nürnberg"></a>
                            </p>
                            <p>
                                <a title="CrossAsia" href="https://crossasia.org/"><img src="https://crossasia.org/fileadmin/media/CrossAsia_Logo_farbig.jpg" width="200"  alt="Supported by CrossAsia"></a>
                            </p>
                        </div>
                    </div>

                </div> <!-- end: menu -->

                <!-- CONTENT ****************************************************************** -->
                <!-- ************************************************************************** -->
                <div id="content">
                    <!-- begin: content -->
                    <router-view></router-view>
                </div> <!-- end: content -->
            </div><!-- end: main -->
            <div id="footer">
                <!-- begin: footer -->
                <h2><a name="footermarke" id="footermarke">Status information:</a></h2>
                <p class="last_modified">Last modified: May 23, 2019 at 2:01 PM</p>
                <div id="footerinfos">
                    <!-- begin: footerinfos -->

                    <div id="tecmenu">
                        <!-- begin: tecmenu -->
                        <h2 class="skip"><a name="hilfemarke" id="hilfemarke">Technisches Menu</a></h2>
                        <ul>
                            <li class="first"><a href="//http://www.ikgf.uni-erlangen.de/imprint.shtml">Imprint</a><span class="skip">. </span></li>
                            <li><a href="//http://www.ikgf.uni-erlangen.de/suche.shtml">Search</a><span class="skip">. </span></li>
                            <li><a href="//http://www.ikgf.uni-erlangen.de/sitemap.shtml">Sitemap</a><span class="skip">. </span></li>
                            <li><a href="//http://www.ikgf.uni-erlangen.de/wiki/">Login</a><span class="skip">. </span></li>
                            <li class="last"><a href="https://www.facebook.com/pages/IKGF-Erlangen/366443570204225">Facebook</a><span class="skip">. </span></li>
                        </ul>
                    </div><!-- end: tecmenu -->
                    <div id="zusatzinfo" class="noprint">
                        <a id="zusatzinfomarke" name="zusatzinfomarke"></a>
                        <div class="noprint">

                            <div>
                                <template v-if="selectedTopics.length > 0">
                                    <h3>Selected Topics<br />({{selectedTopics.length}} / {{topics.length}} )</h3>
                                    <template v-for="(chip, i) of selectedTopics">
                                        <!-- {{chip}} -->
                                        <p :key='i'><em><strong>{{chip}}</strong>
                                                <font-awesome-icon icon="times-circle" v-on:click="removeTopic(chip)" /></em></p>
                                    </template>
                                    <p style="margin-top:13px; "><a class="intern" v-on:click.stop.prevent="removeAllTopics()">Remove all topics …</a></p>
                                    <hr>
                                </template>

                                <template v-if="selectedAuthors.length > 0">
                                    <h3>Selected Authors<br />({{selectedAuthors.length}}/{{authors.length}})</h3>
                                    <template v-for="(chip, i) of selectedAuthors">
                                        <!-- {{chip}} -->
                                        <p :key='i'><em><strong>{{chip}}</strong>
                                                <font-awesome-icon icon="times-circle" v-on:click="removeAuthor(chip)" /></em></p>
                                    </template>
                                    <p style="margin-top:13px; "><a class="intern" v-on:click.stop.prevent="removeAllAuthors()">Remove all topics …</a></p>
                                    <hr>
                                </template>
                            </div> <!-- end: footerinfos -->
                        </div> <!-- end: footer -->

                    </div> <!-- end: seite -->
                </div> <!-- end: page_margins  -->
                <!-- end: body -->

            </div>
        </div>
    </div>
    <div id="overlay" style="display: none;"></div>
    <div id="lightbox" style="display: none;">
        <div id="outerImageContainer" style="width: 250px; height: 250px;">
            <div id="imageContainer"><img id="lightboxImage">
                <div id="hoverNav"><a id="prevLink" href="#"></a><a id="nextLink" href="#"></a></div>
                <div id="loading"><a id="loadingLink" href="#"><img src="/img/loading.gif"></a></div>
            </div>
        </div>
        <div id="imageDataContainer">
            <div id="imageData">
                <div id="imageDetails"><span id="caption"></span><span id="numberDisplay"></span></div>
                <div id="bottomNav"><a id="bottomNavClose" href="#"><img src="/img/closelabel.gif"></a></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import {
    library
} from '@fortawesome/fontawesome-svg-core'
import {
    faTimesCircle
} from '@fortawesome/free-solid-svg-icons'
import {
    FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

library.add(faTimesCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)
export default {
    data: function () {
        return {}
    },
    computed: {
        selectedTopics: {
            set(val) {
                this.$store.dispatch('selectedTopics', val)
            },
            get() {
                return this.$store.getters.getSelectedTopics
            }
        },
        topics() {
            return this.$store.getters.getTopics
        },
        authors() {
            return this.$store.getters.getAuthors
        },
        selectedAuthors: {
            set(val) {
                this.$store.dispatch('selectedAuthors', val)
            },
            get() {
                return this.$store.getters.getSelectedAuthors
            }
        },
        noOfPublications() {
            return this.$store.getters.getNoOfPublications
        }
    },
    methods: {
        removeTopic(topic) {
            this.selectedTopics = this.selectedTopics.filter(x => x !== topic)
        },
        removeAuthor(author) {
            this.selectedAuthors = this.selectedAuthors.filter(x => x !== author)
        },
        removeAllTopics(topic) {
            this.$store.dispatch('selectedTopics', [])
        },
        removeAllAuthors(topic) {
            this.$store.dispatch('selectedAuthors', [])
        }
    }
}
</script>

<style>
#main_holder {
    min-height: 0em;
    border-width: 0px;
}

#content_holder {
    margin: 0em 0em 0em 0em;
    min-height: 0em;
    padding: 1em;
}

#menu_holder {
    border-top-width: 1px;
    margin-top: 0px;
    width: auto;
    min-width: 0;
    margin-left: 0px;
}

#footer_holder {
    background-color: #f1dfb3;
    margin: 1em 1em 0em 0em;
    padding: 0.2em;
}

.tab-content {
    background-color: white;
    padding: 0.2em;
    border-bottom-width: 1px;
    border-left-width: 1px;
    border-right-width: 1px;
    padding: 10px;
    border-style: solid;
    border-color: #ddd #ddd #fff;
}

pre {
    white-space: pre-wrap;
    /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;
    /* Mozilla, since 1999 */
    white-space: -pre-wrap;
    /* Opera 4-6 */
    white-space: -o-pre-wrap;
    /* Opera 7 */
    word-wrap: break-word;
    /* Internet Explorer 5.5+ */
}

.pagination li {
    min-width: 3em;
}

.chip {
    display: inline-block;
    background: #f1dfb3;
    padding: 0 12px;
    border-radius: 32px;
    font-size: 13px;
}

.chip:hover {
    background: #ccc;
}

.chip-remove {
    display: inline-block;
    background: #aaa;
    border: 0;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    padding: 0;
    margin: 0 -0.5rem 0 0;
    cursor: pointer;
    font: inherit;
    line-height: 20px;
    text-align: center;
}

.chip-remove:after {
    content: 'x';
}

.chip-remove:hover {
    background: #999;
}

.chip-remove:active {
    background: #777;
}

.chip {
    height: 2.5rem;
    line-height: 2.5rem;
}

.chips {
    padding: 0.5rem 0;

}

.chip {
    margin: 0 0.5rem 3px 0;
}

strong {
    padding-right: 0.3rem;
}
</style>
